import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/header/Header";
import BlogCard from "../../components/blog/BlogCard";
import Footer from "../../components/footer/Footer";
import BackToTop from "../../components/backToTop/BackToTop";
import { getAllBlogs, getBlogBySlug } from "../../utils/loadBlogs";
import "./BlogPage.css";

const categories = [
  "All",
  "Computer science",
  "Data science",
  "Python",
  "Business",
  "Information Technology",
  "Leadership",
  "Communication",
];

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [activeTab, setActiveTab] = useState("All");
  const [visibleCount, setVisibleCount] = useState(9); // initial visible blogs
  const LOAD_STEP = 6;

  // useEffect(() => {
  //   getAllBlogs().then(setBlogs);
  // }, []);

    useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const data = await getAllBlogs();

        setBlogs(data);
      } catch (error) {
        console.error("Blog loading failed:", error);
      }
    };
    fetchBlogs();
  }, []);

  useEffect(() => {
    setVisibleCount(6);
  }, [activeTab]);

  const categories = ["All", ...new Set(blogs.map((b) => b.category))];

  // Sort blogs (newest first)
  const sortedBlogs = [...blogs].sort(
    (a, b) => new Date(b.date) - new Date(a.date),
  );

  // Split blogs
  const latestBlogs = sortedBlogs.slice(0, 3); // latest 6
  const moreBlogs = sortedBlogs.slice(3); // older ones

  // Filter Latest
  const filteredLatestBlogs =
    activeTab === "All"
      ? latestBlogs
      : latestBlogs.filter((blog) => blog.category === activeTab);

  // Filter More
  const filteredMoreBlogs =
    activeTab === "All"
      ? moreBlogs
      : moreBlogs.filter((blog) => blog.category === activeTab);

  const paginatedMoreBlogs = filteredMoreBlogs.slice(0, visibleCount);

  const filteredBlogs =
    activeTab === "All"
      ? blogs
      : blogs.filter((blog) => blog.category === activeTab);

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + LOAD_STEP);
  };

  return (
    <div className="blog-page">
      <Helmet>
        <title>Blog | TutorsLinks</title>
        <meta
          name="description"
          content="Insights, exam tips, and guides for JAMB, WAEC, NECO, adult education, and finding the right tutor or training centre in Nigeria."
        />
        <link rel="canonical" href="https://www.tutorslinks.com/blog" />
      </Helmet>

      <Header />

      {/* HERO SECTION */}
      <section className="blog-hero">
        <div className="blog-hero-container">
          <div className="hero-image">
            <img
              src="/images/blog-hero.png"
              alt="TutorsLinks blog — education insights and exam tips"
              width={1200}
              height={400}
              loading="eager"
            />
            <div className="hero-overlay"></div>
          </div>

          <div className="hero-text">
            <h1>Explore Our Latest Articles</h1>
            <p>
              "Stay ahead of the curve with our latest insights, trends, and
              best practices in e-learning and education. Our blog is dedicated
              to providing you with valuable resources, expert tips, and
              thought-provoking articles to enhance your learning experience."
            </p>
          </div>
        </div>
      </section>

      {/* LATEST BLOGS */}
      <section className="latest-blogs">
        <div className="more-hero-container">
          <h2 className="section-title">Latest Blog Posts</h2>

          {/* CATEGORY TABS */}
          <div className="category-tabs">
            {categories.map((cat, idx) => (
              <button
                key={cat}
                className={`tab ${activeTab === cat ? "active" : ""}`}
                onClick={() => setActiveTab(cat)}
              >
                {cat}
              </button>
            ))}
            <span
              className="tab-slider"
              style={{
                transform: `translateX(${categories.indexOf(activeTab) * 100}%)`,
              }}
            />
          </div>

          {/* BLOG GRID */}
          <div className="blog-grid">
            {filteredLatestBlogs.map((blog) => (
              <BlogCard key={blog.slug} blog={blog} />
            ))}
          </div>
        </div>
      </section>

      {/* MORE BLOGS */}
      <section className="more-blogs">
        <div className="more-hero-container">
          <h2 className="section-title">More Articles from our Community</h2>
          <div className="blog-grid">
            {paginatedMoreBlogs.map((blog) => (
              <BlogCard key={blog.slug} blog={blog} />
            ))}
          </div>

          {/* LOAD MORE BUTTON */}
          {visibleCount < filteredMoreBlogs.length && (
            <div className="load-more-wrapper">
              <button className="load-more-btn" onClick={handleLoadMore}>
                Load More
              </button>
            </div>
          )}
        </div>
      </section>

      {visibleCount >= filteredMoreBlogs.length && (
        <p className="no-more">No more articles to load</p>
      )}

      <Footer />
      <BackToTop />
    </div>
  );
};

export default BlogPage;
